import React from "react";
import "./Legal.css";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

const Legal = () => {
  return (
    <div className="legal-container">
      <h1>Legal Notice</h1>
      <p>Last updated: June 29, 2025</p>

      <p>
        Blockcode LLC (“we”, “us”, or “our”) provides this website (“Blockcode”). By
        using this site, you agree to comply with the following terms:
      </p>

      <h2>1. Use of Content</h2>
      <p>
        All content is for educational purposes only. You may not redistribute, rebrand,
        or commercialize Blockcode’s materials without permission.
      </p>

      <h2>2. User Responsibility</h2>
      <p>
        Users are responsible for all activity under their account. Do not share login
        credentials or attempt to misuse the platform.
      </p>

      <h2>3. No Warranty</h2>
      <p>
        This site is provided “as is.” We make no guarantees as to performance, uptime,
        or accuracy of content. <strong>WE HEREBY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE.</strong>
      </p>

      <h2>4. Limitation of Liability</h2>
      <p>
        <strong>
          IN NO EVENT WILL WE, OUR AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS,
          EMPLOYEES, AGENTS, OFFICERS OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND,
          UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR
          INABILITY TO USE, THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE
          WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
          WEBSITE OR SUCH OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL,
          INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO,
          PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS
          OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF
          GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE),
          BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.
        </strong>
      </p>
      <p>
        <strong>
          THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED
          UNDER APPLICABLE LAW.
        </strong>
      </p>

      <h2>5. Indemnity</h2>
      <p>
        You agree to defend, indemnify and hold harmless us, our affiliates, licensors
        and service providers, and its and their respective officers, directors,
        employees, contractors, agents, licensors, suppliers, successors and assigns
        from and against any claims, liabilities, damages, judgments, awards, losses,
        costs, expenses or fees (including reasonable attorneys' fees) arising out of or
        relating to your violation of these terms of use or your use of the Website,
        including, but not limited to, your contributions, any use of the Website's
        content, services and products other than as expressly authorized in these terms
        of use or your use of any information obtained from the Website.
      </p>

      <h2>6. Governing Law and Jurisdiction</h2>
      <p>
        All matters relating to the Website and these terms of use and any dispute or
        claim arising therefrom or related thereto (in each case, including
        non-contractual disputes or claims), shall be governed by and construed in
        accordance with the internal laws of the State of New York without giving effect
        to any choice or conflict of law provision or rule (whether of the State of New
        York or any other jurisdiction).
      </p>
      <p>
        Any legal suit, action or proceeding arising out of, or related to, these terms
        of use or the Website shall be instituted exclusively in the federal courts of
        the United States or the courts of the State of New York in each case located in
        the City of New York and County of New York, although we retain the right to
        bring any suit, action or proceeding against you for breach of these terms of
        use in your country of residence or any other relevant country. You waive any and
        all objections to the exercise of jurisdiction over you by such courts and to
        venue in such courts.
      </p>

      <h2>7. Changes to These Terms</h2>
      <p>
        We reserve the right to modify these terms at any time. Continued use of the
        platform means you accept any changes.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        For legal inquiries or questions, please <Link to="/contactus">contact us</Link>.
      </p>

      <Footer />
    </div>
  );
};

export default Legal;
